"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.fill.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _default = exports.default = {
  methods: {
    /** 获取 行操作列 宽度
     * @description: 计算表格操作列中每一行的宽度，然后获取最宽的一行作为行宽
     * @return { Number } 计算后的行宽
     */
    getOperationsWidth: function getOperationsWidth() {
      var _this = this;
      this.$nextTick(function () {
        return _this.doLayout();
      });
      var minW = 50;
      return Object.keys(this.$refs).filter(function (key) {
        return key.includes('row-operations');
      }).map(function (key) {
        try {
          var dom = _this.$refs[key];
          var p = _this.$$getDomSize(dom === null || dom === void 0 ? void 0 : dom.parentNode, 'padding-left') + _this.$$getDomSize(dom === null || dom === void 0 ? void 0 : dom.parentNode, 'padding-right');
          var w = (dom === null || dom === void 0 ? void 0 : dom.clientWidth) + p + 2;
          return w > minW ? w : minW;
        } catch (e) {
          return minW;
        }
      }).sort(function (x, y) {
        return x - y;
      }).pop();
    },
    /** 获取行操作按钮
     * @param { Object } row 行数据对象
     * @return { void }
     */
    getRowOperations: function getRowOperations(row) {
      var key = this.$$getMD5(row);
      return this.tableRowOperations.find(function (btns) {
        return Array.isArray(btns) && JSON.stringify(btns).includes(key);
      });
    },
    /** 行按钮显示分割线
     * @description: 行操作按钮是否显示分割线
     * @param { Number } rowIndex 行下标
     * @param { Number } index 行按钮下标
     * @param { Object } btn 按钮
     * @return { void }
     */
    rowBtnsCrossLine: function rowBtnsCrossLine(rowIndex, index /* , btn */) {
      var _this2 = this;
      /* 如果第一个按钮就不显示左侧的分割线 */
      if (index === 0) return false;

      /* 判断按钮是否存在 */
      var a = function a(i) {
        var btns = _this2.$refs["row-operation-".concat(rowIndex, "-").concat(i)];
        var b = btns === null || btns === void 0 ? void 0 : btns.some(function (ref) {
          return !!(ref !== null && ref !== void 0 && ref.$el) && _this2.$$dataTypeOf(ref === null || ref === void 0 ? void 0 : ref.$el, 0) !== 'comment' && _this2.$$getOriginalStyle(ref === null || ref === void 0 ? void 0 : ref.$el, 'display') !== 'none';
        });
        return !!btns && b;
      };
      return a(index) && typeof new Array(index).fill('').find(function (v, i) {
        return a(i);
      }) !== 'undefined';
    },
    /** 表格行操作点击事件
     * @description: 表格行操作点击事件
     * @param { Object } scope 行对象
     * @param { Object } btn 按钮参数对象
     * @param { Array } btns 当前行所有按钮集
     * @param { Object } e 点击事件对象
     * @return { void }
     */
    tableRowOperationsClick: function tableRowOperationsClick(scope, btn, btns, e) {
      var _this3 = this;
      var row = scope.row,
        $index = scope.$index;
      this.$$debounce(function () {
        _this3.doLayout();
        typeof btn.click === 'function' && btn.click(row, $index, btn, btns, e);
        typeof btn.onclick === 'function' && btn.onclick(row, $index, btn, btns, e);
        typeof btn.onClick === 'function' && btn.onClick(row, $index, btn, btns, e);
      }, 50);
    }
  }
};